import { useTranslation } from 'react-i18next';

export function Loading({ className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent-strong"></div>
      <span className="ml-3 text-slate-400">{t('common.loading')}</span>
    </div>
  );
}

export function Skeleton({ className = '' }) {
  return (
    <div className={`animate-pulse bg-slate-700/70 rounded ${className}`}></div>
  );
}

export function CardSkeleton() {
  return (
    <div className="glass-card p-4 space-y-3">
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
      <div className="flex gap-2">
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="h-10 flex-1" />
      </div>
    </div>
  );
}
